// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".firmador-select[data-v-7d2edf76] {\n  width: 75px;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
